import { dwgl } from '@/axios';
import { Message } from 'element-ui';
let that;
export default{
	data(){
		return{
			datas:""
		}
	},
	mounted() {
		that.getdata();
	},
	created() {
		that = this;
		that.$emit('selectTop',2)
	},
	methods:{
		// 获取数据
		getdata(){
			var that = this;
			dwgl.updatePartyAffairsGet({
				id:that.$route.query.id
			}).then(res => {
				if(res.code == 200){
					that.datas = res.data;
				}else{
					Message.error(res.msg)
				}
			})
		},
		// 编辑
		goedit(){
			var that = this;
			that.$router.push({
				path:"/dwgk_add",
				query:{
					id:that.$route.query.id,
					flag:that.$route.query.flag,
					type:'edit'
				}
			})
		},
		// 文件下载
		download(url){
			if(url){
				location.href = url
			}else{
				Message.error('下载失败')
			}
		}
	}
}